module.exports = __webpack_public_path__ + "assets/img/block-b05264f7.png";